import {get, writable} from 'svelte/store';

import {buildKarts}       from '../../services/build-karts';
import {bodyTypesStore}   from '../filters/body-types-store';
import {driverSizesStore} from '../filters/driver-sizes-store';
import {driverStore}      from '../filters/driver-store';

const createStore = () => {
  // Using derived() with bodyTypesStore, driverSizesStore, and driverStore as dependencies
  // triggers redundant recalculations when multiple stores change (ex. when a Quick
  // Pick is selected). Instead, use subscribe() and freeze/unfreeze/refresh this
  // store's value explicitly.
  const {subscribe, set} = writable(calculate());

  let frozen = true;

  function calculate() {
    const karts = buildKarts(get(driverSizesStore), get(driverStore), get(bodyTypesStore));

    return {
      counts: {
        built: karts.length
      },
      karts
    };
  }

  const refresh = () => { set(calculate()); };
  const freeze = () => { frozen = true; };
  const unfreeze = () => { frozen = false; };

  bodyTypesStore.subscribe(() => { if (!frozen) refresh(); });
  driverSizesStore.subscribe(() => { if (!frozen) refresh(); });
  driverStore.subscribe(() => { if (!frozen) refresh(); });

  unfreeze();

  return {subscribe, refresh, freeze, unfreeze};
};

export const results1BuiltStore = createStore();
